import Home from "./pages/Home";
import HRBP from "./pages/HRBP";
import Professionals from "./pages/Professionals";
import Recruiters from "./pages/Recruiters";
import HowItWorks from "./pages/HowItWorks";
import SecurityAndData from "./pages/SecurityAndData";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

//Styling
import "./styles/App.css";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

//Routing
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

function App() {
    return (
        <div>
            <Router>
                <ScrollToTop />
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />}></Route>
                    
                    {/* How it works */}
                    <Route path="/how-it-works" element={<HowItWorks />}></Route>
                    
                    {/* HRBP routes - lowercase primary, redirect from uppercase */}
                    <Route path="/hrbp" element={<HRBP />}></Route>
                    <Route path="/HRBP" element={<Navigate to="/hrbp" replace />}></Route>
                    
                    {/* Managers routes - redirect to how-it-works */}
                    <Route path="/managers" element={<Navigate to="/how-it-works" replace />}></Route>
                    <Route path="/Managers" element={<Navigate to="/how-it-works" replace />}></Route>
                    
                    {/* Professionals routes - lowercase primary, redirect from uppercase */}
                    <Route path="/professionals" element={<Professionals />}></Route>
                    <Route path="/Professionals" element={<Navigate to="/professionals" replace />}></Route>
                    
                    {/* Recruiters routes - lowercase primary, redirect from uppercase */}
                    <Route path="/recruiters" element={<Recruiters />}></Route>
                    <Route path="/Recruiters" element={<Navigate to="/recruiters" replace />}></Route>
                    
                    {/* Security and data */}
                    <Route path="/security-and-data" element={<SecurityAndData />}></Route>
                    
                    {/* About */}
                    <Route path="/about" element={<About />}></Route>
                    
                    {/* Contact */}
                    <Route path="/contact" element={<Contact />}></Route>
                    
                    {/* 404 catch-all */}
                    <Route path="*" element={<NotFound />}></Route>
                </Routes>
                <Footer />
            </Router>
        </div>
    );
}

export default App;
